export const pitch = {
  extends: 'Page',
  flow: 'y',
  align: 'center center',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  overflow: 'hidden',
  state: {
    slide: 0
  },
  SlideWrapper: {
    flow: 'y',
    align: 'center center',
    width: '100%',
    flex: '1',
    position: 'relative',
    SlideCover: {
      show: (el, s) => s.slide === 0,
      flow: 'y',
      align: 'center center',
      gap: 'A',
      padding: 'C B',
      textAlign: 'center',
      width: '100%',
      SlideNumber: {
        text: '01 / 08',
        fontSize: 'Y',
        color: 'inkMuted',
        letterSpacing: '2px'
      },
      TitleGeorgian: {
        tag: 'h1',
        text: '{{ dcai | polyglot }}',
        fontSize: 'E',
        fontWeight: '800',
        color: 'inkText',
        lineHeight: '1'
      },
      TitleEnglish: {
        tag: 'h2',
        text: '{{ dentalBookingOpsPlatform | polyglot }}',
        fontSize: 'C',
        fontWeight: '300',
        color: 'teal'
      },
      Subtitle: {
        text: '{{ theMissingInfrastructureFor | polyglot }}',
        fontSize: 'A2',
        color: 'inkSubtle',
        maxWidth: 'H',
        marginTop: 'A'
      },
      TagRow: {
        flow: 'x',
        gap: 'A',
        align: 'center center',
        marginTop: 'B',
        TagBook: {
          tag: 'span',
          text: '{{ book | polyglot }}',
          padding: 'X B',
          round: 'Z',
          background: 'teal',
          color: 'ink',
          fontWeight: '700',
          fontSize: 'Z2'
        },
        TagManage: {
          tag: 'span',
          text: '{{ manage | polyglot }}',
          padding: 'X B',
          round: 'Z',
          background: 'tealLight',
          color: 'tealDark',
          fontWeight: '700',
          fontSize: 'Z2',
          border: '1px solid',
          borderColor: 'primary'
        },
        TagGrow: {
          tag: 'span',
          text: '{{ grow | polyglot }}',
          padding: 'X B',
          round: 'Z',
          background: 'tealLight',
          color: 'tealDark',
          fontWeight: '700',
          fontSize: 'Z2',
          border: '1px solid',
          borderColor: 'primary'
        }
      }
    },
    SlideMarket: {
      show: (el, s) => s.slide === 1,
      flow: 'y',
      gap: 'B',
      padding: 'C B',
      maxWidth: 'J',
      width: '100%',
      SlideNumber: {
        text: '02 / 08',
        fontSize: 'Y',
        color: 'inkMuted',
        letterSpacing: '2px'
      },
      SlideTitle: {
        tag: 'h2',
        text: '{{ marketSize | polyglot }}',
        fontSize: 'D',
        fontWeight: '800',
        color: 'inkText',
        marginBottom: 'A'
      },
      StatsRow: {
        flow: 'x',
        gap: 'B',
        '@tabletS': {
          flow: 'y'
        },
        StatTotal: {
          flow: 'y',
          flex: '1',
          padding: 'B',
          round: 'A',
          background: 'inkMid',
          gap: 'Y',
          StatNumber: {
            text: '600–1,000',
            fontSize: 'D',
            fontWeight: '800',
            color: 'teal'
          },
          StatLabel: {
            text: '{{ dentalClinicsInGeorgia | polyglot }}',
            fontSize: 'Z2',
            color: 'inkSubtle'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        StatTbilisi: {
          flow: 'y',
          flex: '1',
          padding: 'B',
          round: 'A',
          background: 'inkMid',
          gap: 'Y',
          StatNumber: {
            text: '400–600',
            fontSize: 'D',
            fontWeight: '800',
            color: 'teal'
          },
          StatLabel: {
            text: '{{ inTbilisiAlone | polyglot }}',
            fontSize: 'Z2',
            color: 'inkSubtle'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        StatPlatforms: {
          flow: 'y',
          flex: '1',
          padding: 'B',
          round: 'A',
          background: 'inkMid',
          gap: 'Y',
          StatNumber: {
            text: '0',
            fontSize: 'D',
            fontWeight: '800',
            color: 'amber'
          },
          StatLabel: {
            text: '{{ unifiedBookingOrOps | polyglot }}',
            fontSize: 'Z2',
            color: 'inkSubtle'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        }
      },
      IncumbentNote: {
        padding: 'A',
        round: 'Z',
        background: 'inkSurface',
        border: '1px solid',
        borderColor: 'inkBorder',
        NoteText: {
          text: '{{ dentosgeIsTheOnly | polyglot }}',
          fontSize: 'Z2',
          color: 'inkMuted'
        }
      }
    },
    SlideProblem: {
      show: (el, s) => s.slide === 2,
      flow: 'y',
      gap: 'B',
      padding: 'C B',
      maxWidth: 'J',
      width: '100%',
      SlideNumber: {
        text: '03 / 08',
        fontSize: 'Y',
        color: 'inkMuted',
        letterSpacing: '2px'
      },
      SlideTitle: {
        tag: 'h2',
        text: '{{ theProblem | polyglot }}',
        fontSize: 'D',
        fontWeight: '800',
        color: 'inkText',
        marginBottom: 'A'
      },
      ProblemList: {
        flow: 'y',
        gap: 'A',
        ProblemExcel: {
          flow: 'x',
          align: 'center',
          gap: 'A',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          ProblemEmoji: {
            text: '📋',
            fontSize: 'B'
          },
          ProblemContent: {
            flow: 'y',
            gap: 'X',
            ProblemHeading: {
              text: '{{ clinicsRunOnExcel | polyglot }}',
              fontWeight: '600',
              color: 'inkText'
            },
            ProblemDetail: {
              text: '{{ noStructuredWorkflowConstant | polyglot }}',
              color: 'inkMuted',
              fontSize: 'Z2'
            }
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        ProblemNoShows: {
          flow: 'x',
          align: 'center',
          gap: 'A',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          ProblemEmoji: {
            text: '📉',
            fontSize: 'B'
          },
          ProblemContent: {
            flow: 'y',
            gap: 'X',
            ProblemHeading: {
              text: '{{ noshowsCost1525Of | polyglot }}',
              fontWeight: '600',
              color: 'inkText'
            },
            ProblemDetail: {
              text: '{{ noAutomatedRemindersOr | polyglot }}',
              color: 'inkMuted',
              fontSize: 'Z2'
            }
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        ProblemInsurance: {
          flow: 'x',
          align: 'center',
          gap: 'A',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          ProblemEmoji: {
            text: '🏦',
            fontSize: 'B'
          },
          ProblemContent: {
            flow: 'y',
            gap: 'X',
            ProblemHeading: {
              text: '{{ insuranceBillingIsManual | polyglot }}',
              fontWeight: '600',
              color: 'inkText'
            },
            ProblemDetail: {
              text: 'Aldagi, GPI, Imedi L — all handled via phone and paper forms',
              color: 'inkMuted',
              fontSize: 'Z2'
            }
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        ProblemBooking: {
          flow: 'x',
          align: 'center',
          gap: 'A',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          ProblemEmoji: {
            text: '📵',
            fontSize: 'B'
          },
          ProblemContent: {
            flow: 'y',
            gap: 'X',
            ProblemHeading: {
              text: `Patients can't book online 24/7`,
              fontWeight: '600',
              color: 'inkText'
            },
            ProblemDetail: {
              text: '{{ dentalTourismPatientsEspeciall | polyglot }}',
              color: 'inkMuted',
              fontSize: 'Z2'
            }
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        }
      }
    },
    SlideSolution: {
      show: (el, s) => s.slide === 3,
      flow: 'y',
      gap: 'B',
      padding: 'C B',
      maxWidth: 'J',
      width: '100%',
      SlideNumber: {
        text: '04 / 08',
        fontSize: 'Y',
        color: 'inkMuted',
        letterSpacing: '2px'
      },
      SlideTitle: {
        tag: 'h2',
        text: '{{ theSolution | polyglot }}',
        fontSize: 'D',
        fontWeight: '800',
        color: 'inkText',
        marginBottom: 'A'
      },
      SolutionGrid: {
        flow: 'x',
        gap: 'A',
        flexWrap: 'wrap',
        SolutionBooking: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          flex: '1',
          minWidth: 'G',
          SolutionEmoji: {
            text: '📅',
            fontSize: 'B'
          },
          SolutionHeading: {
            text: '{{ onlineBookingWidgetMarketplace | polyglot }}',
            fontWeight: '600',
            color: 'inkText',
            fontSize: 'Z2'
          },
          SolutionDetail: {
            text: '{{ patientsBook247From | polyglot }}',
            color: 'inkMuted',
            fontSize: 'Y'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        SolutionRecords: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          flex: '1',
          minWidth: 'G',
          SolutionEmoji: {
            text: '🦷',
            fontSize: 'B'
          },
          SolutionHeading: {
            text: '{{ patientRecordsTreatmentManagem | polyglot }}',
            fontWeight: '600',
            color: 'inkText',
            fontSize: 'Z2'
          },
          SolutionDetail: {
            text: '{{ fullHistoryTreatmentPlans | polyglot }}',
            color: 'inkMuted',
            fontSize: 'Y'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        SolutionInsurance: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          flex: '1',
          minWidth: 'G',
          SolutionEmoji: {
            text: '🏥',
            fontSize: 'B'
          },
          SolutionHeading: {
            text: '{{ insuranceIntegrations | polyglot }}',
            fontWeight: '600',
            color: 'inkText',
            fontSize: 'Z2'
          },
          SolutionDetail: {
            text: 'Aldagi, GPI, Imedi L — automated',
            color: 'inkMuted',
            fontSize: 'Y'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        SolutionReminders: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          flex: '1',
          minWidth: 'G',
          SolutionEmoji: {
            text: '💬',
            fontSize: 'B'
          },
          SolutionHeading: {
            text: '{{ smsWhatsappReminders | polyglot }}',
            fontWeight: '600',
            color: 'inkText',
            fontSize: 'Z2'
          },
          SolutionDetail: {
            text: '{{ cutNoshowsByUp | polyglot }}',
            color: 'inkMuted',
            fontSize: 'Y'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        SolutionFinance: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          flex: '1',
          minWidth: 'G',
          SolutionEmoji: {
            text: '📊',
            fontSize: 'B'
          },
          SolutionHeading: {
            text: '{{ financialReportingDashboard | polyglot }}',
            fontWeight: '600',
            color: 'inkText',
            fontSize: 'Z2'
          },
          SolutionDetail: {
            text: '{{ revenueSalariesExpensesRealtim | polyglot }}',
            color: 'inkMuted',
            fontSize: 'Y'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        }
      }
    },
    SlidePricing: {
      show: (el, s) => s.slide === 4,
      flow: 'y',
      gap: 'B',
      padding: 'C B',
      maxWidth: 'J',
      width: '100%',
      SlideNumber: {
        text: '05 / 08',
        fontSize: 'Y',
        color: 'inkMuted',
        letterSpacing: '2px'
      },
      SlideTitle: {
        tag: 'h2',
        text: '{{ willingnessToPay | polyglot }}',
        fontSize: 'D',
        fontWeight: '800',
        color: 'inkText',
        marginBottom: 'A'
      },
      PricingRow: {
        flow: 'x',
        gap: 'A',
        '@tabletS': {
          flow: 'y'
        },
        PricingFree: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          flex: '1',
          PricingTier: {
            text: '{{ free | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkMuted',
            letterSpacing: '2px',
            textTransform: 'uppercase'
          },
          PricingAmount: {
            text: '₾0',
            fontSize: 'C',
            fontWeight: '800',
            color: 'inkText'
          },
          PricingPeriod: {
            text: '{{ month | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
          },
          PricingDescription: {
            text: '{{ listingBookingWidget | polyglot }}',
            fontSize: 'Y',
            color: 'inkSubtle',
            marginTop: 'Y'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        PricingGrowth: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'inkSurface',
          border: '1px solid',
          borderColor: 'teal',
          flex: '1',
          PricingTier: {
            text: '{{ growth | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'teal',
            letterSpacing: '2px',
            textTransform: 'uppercase'
          },
          PricingAmount: {
            text: '₾49',
            fontSize: 'C',
            fontWeight: '800',
            color: 'inkText'
          },
          PricingPeriod: {
            text: '{{ month | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
          },
          PricingDescription: {
            text: '{{ calendarRemindersPatientCards | polyglot }}',
            fontSize: 'Y',
            color: 'inkSubtle',
            marginTop: 'Y'
          }
        },
        PricingPro: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'teal',
          flex: '1',
          PricingTier: {
            text: '{{ pro | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'ink',
            letterSpacing: '2px',
            textTransform: 'uppercase'
          },
          PricingAmount: {
            text: '₾149',
            fontSize: 'C',
            fontWeight: '800',
            color: 'ink'
          },
          PricingPeriod: {
            text: '{{ month | polyglot }}',
            fontSize: 'Y',
            color: 'inkMid'
          },
          PricingDescription: {
            text: '{{ fullOpsInsuranceAnalytics | polyglot }}',
            fontSize: 'Y',
            color: 'inkMid',
            marginTop: 'Y'
          },
          border: '1px solid',
          borderColor: 'tealDark'
        },
        PricingEnterprise: {
          flow: 'y',
          gap: 'Y',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          flex: '1',
          PricingTier: {
            text: '{{ navEnterprise | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkMuted',
            letterSpacing: '2px',
            textTransform: 'uppercase'
          },
          PricingAmount: {
            text: '₾300+',
            fontSize: 'C',
            fontWeight: '800',
            color: 'inkText'
          },
          PricingPeriod: {
            text: '{{ month | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
          },
          PricingDescription: {
            text: '{{ multibranchApiAccessReporting | polyglot }}',
            fontSize: 'Y',
            color: 'inkSubtle',
            marginTop: 'Y'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        }
      },
      PricingNote: {
        text: '{{ wtp0515OfMonthly | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        textAlign: 'center',
        marginTop: 'A'
      }
    },
    SlideOpportunity: {
      show: (el, s) => s.slide === 5,
      flow: 'y',
      gap: 'B',
      padding: 'C B',
      maxWidth: 'J',
      width: '100%',
      SlideNumber: {
        text: '06 / 08',
        fontSize: 'Y',
        color: 'inkMuted',
        letterSpacing: '2px'
      },
      SlideTitle: {
        tag: 'h2',
        text: '{{ marketOpportunity | polyglot }}',
        fontSize: 'D',
        fontWeight: '800',
        color: 'inkText',
        marginBottom: 'A'
      },
      OpportunityRow: {
        flow: 'x',
        gap: 'B',
        '@tabletS': {
          flow: 'y'
        },
        OpportunityClinics: {
          flow: 'y',
          flex: '1',
          padding: 'B',
          round: 'A',
          background: 'inkMid',
          gap: 'Y',
          OpportunityNumber: {
            text: '300',
            fontSize: 'D',
            fontWeight: '800',
            color: 'teal'
          },
          OpportunityLabel: {
            text: '{{ addressableClinicsAtLaunch | polyglot }}',
            color: 'inkSubtle',
            fontSize: 'Z2'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        OpportunityMrr: {
          flow: 'y',
          flex: '1',
          padding: 'B',
          round: 'A',
          background: 'inkMid',
          gap: 'Y',
          OpportunityNumber: {
            text: '₾45K',
            fontSize: 'D',
            fontWeight: '800',
            color: 'teal'
          },
          OpportunityLabel: {
            text: '{{ mrrAtFullPenetration | polyglot }}',
            color: 'inkSubtle',
            fontSize: 'Z2'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        OpportunityUsd: {
          flow: 'y',
          flex: '1',
          padding: 'B',
          round: 'A',
          background: 'inkMid',
          gap: 'Y',
          OpportunityNumber: {
            text: '$16K',
            fontSize: 'D',
            fontWeight: '800',
            color: 'teal'
          },
          OpportunityLabel: {
            text: '{{ initialMrrCeilingUsd | polyglot }}',
            color: 'inkSubtle',
            fontSize: 'Z2'
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        }
      },
      ExpansionNote: {
        padding: 'A',
        round: 'Z',
        background: 'inkSurface',
        border: '1px solid',
        borderColor: 'inkBorder',
        ExpansionText: {
          text: '{{ nextExpansionArmeniaAzerbaijan | polyglot }}',
          fontSize: 'Z2',
          color: 'inkMuted'
        }
      }
    },
    SlideWhyNow: {
      show: (el, s) => s.slide === 6,
      flow: 'y',
      gap: 'B',
      padding: 'C B',
      maxWidth: 'J',
      width: '100%',
      SlideNumber: {
        text: '07 / 08',
        fontSize: 'Y',
        color: 'inkMuted',
        letterSpacing: '2px'
      },
      SlideTitle: {
        tag: 'h2',
        text: '{{ whyNow | polyglot }}',
        fontSize: 'D',
        fontWeight: '800',
        color: 'inkText',
        marginBottom: 'A'
      },
      ReasonList: {
        flow: 'y',
        gap: 'A',
        ReasonTourism: {
          flow: 'x',
          align: 'center',
          gap: 'A',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          ReasonEmoji: {
            text: '✈️',
            fontSize: 'B'
          },
          ReasonContent: {
            flow: 'y',
            gap: 'X',
            ReasonHeading: {
              text: '{{ dentalTourismBoom | polyglot }}',
              fontWeight: '600',
              color: 'inkText'
            },
            ReasonDetail: {
              text: '{{ internationalPatientsNeedEngli | polyglot }}',
              color: 'inkMuted',
              fontSize: 'Z2'
            }
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        ReasonDigital: {
          flow: 'x',
          align: 'center',
          gap: 'A',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          ReasonEmoji: {
            text: '📱',
            fontSize: 'B'
          },
          ReasonContent: {
            flow: 'y',
            gap: 'X',
            ReasonHeading: {
              text: '{{ postcovidDigitizationPressure | polyglot }}',
              fontWeight: '600',
              color: 'inkText'
            },
            ReasonDetail: {
              text: '{{ clinicsThatSurvivedAre | polyglot }}',
              color: 'inkMuted',
              fontSize: 'Z2'
            }
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        ReasonIncumbent: {
          flow: 'x',
          align: 'center',
          gap: 'A',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          ReasonEmoji: {
            text: '🏆',
            fontSize: 'B'
          },
          ReasonContent: {
            flow: 'y',
            gap: 'X',
            ReasonHeading: {
              text: '{{ noStrongLocalIncumbent | polyglot }}',
              fontWeight: '600',
              color: 'inkText'
            },
            ReasonDetail: {
              text: '{{ dentosgeOnlyCoversDiscovery | polyglot }}',
              color: 'inkMuted',
              fontSize: 'Z2'
            }
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        },
        ReasonHub: {
          flow: 'x',
          align: 'center',
          gap: 'A',
          padding: 'A',
          round: 'A',
          background: 'inkMid',
          ReasonEmoji: {
            text: '{{ str570 | polyglot }}',
            fontSize: 'B'
          },
          ReasonContent: {
            flow: 'y',
            gap: 'X',
            ReasonHeading: {
              text: '{{ georgiaIsAHealthcare | polyglot }}',
              fontWeight: '600',
              color: 'inkText'
            },
            ReasonDetail: {
              text: '{{ lowCostHighQuality | polyglot }}',
              color: 'inkMuted',
              fontSize: 'Z2'
            }
          },
          border: '1px solid',
          borderColor: 'inkBorder'
        }
      }
    },
    SlideCta: {
      show: (el, s) => s.slide === 7,
      flow: 'y',
      align: 'center center',
      gap: 'B',
      padding: 'C B',
      textAlign: 'center',
      width: '100%',
      SlideNumber: {
        text: '08 / 08',
        fontSize: 'Y',
        color: 'inkMuted',
        letterSpacing: '2px'
      },
      CtaTitle: {
        tag: 'h2',
        text: `Let's Build It`,
        fontSize: 'E',
        fontWeight: '800',
        color: 'inkText'
      },
      CtaSubtitle: {
        text: '{{ joinThePartnerClinic | polyglot }}',
        fontSize: 'A2',
        color: 'teal',
        fontWeight: '600'
      },
      CtaDescription: {
        text: `We're onboarding founding clinics to shape the product. No commitment. Full white-glove setup.`,
        fontSize: 'A',
        color: 'inkSubtle',
        maxWidth: 'H',
        lineHeight: '1.6'
      },
      CtaContact: {
        flow: 'y',
        align: 'center center',
        gap: 'Y',
        marginTop: 'A',
        CtaEmail: {
          text: 'hello@dental.ge',
          fontSize: 'B',
          fontWeight: '700',
          color: 'teal'
        },
        CtaTagline: {
          tag: 'span',
          text: '{{ builtForGeorgianClinics | polyglot }}',
          fontSize: 'Z2',
          color: 'inkMuted'
        }
      }
    }
  },
  SlideNav: {
    flow: 'x',
    align: 'center space-between',
    padding: 'A B',
    width: '100%',
    PrevButton: {
      extends: 'Button',
      text: '{{ prev | polyglot }}',
      theme: 'dialog',
      padding: 'Y A',
      round: 'Z',
      show: (el, s) => s.slide > 0,
      onClick: (e, el, s) => s.update({ slide: s.slide - 1 })
    },
    DotIndicators: {
      flow: 'x',
      gap: 'Y',
      align: 'center center',
      DotOne: {
        tag: 'span',
        boxSize: 'Y',
        round: '100%',
        cursor: 'pointer',
        background: (el, s) => (s.slide === 0 ? 'teal' : 'inkBorder'),
        onClick: (e, el, s) => s.update({ slide: 0 })
      },
      DotTwo: {
        tag: 'span',
        boxSize: 'Y',
        round: '100%',
        cursor: 'pointer',
        background: (el, s) => (s.slide === 1 ? 'teal' : 'inkBorder'),
        onClick: (e, el, s) => s.update({ slide: 1 })
      },
      DotThree: {
        tag: 'span',
        boxSize: 'Y',
        round: '100%',
        cursor: 'pointer',
        background: (el, s) => (s.slide === 2 ? 'teal' : 'inkBorder'),
        onClick: (e, el, s) => s.update({ slide: 2 })
      },
      DotFour: {
        tag: 'span',
        boxSize: 'Y',
        round: '100%',
        cursor: 'pointer',
        background: (el, s) => (s.slide === 3 ? 'teal' : 'inkBorder'),
        onClick: (e, el, s) => s.update({ slide: 3 })
      },
      DotFive: {
        tag: 'span',
        boxSize: 'Y',
        round: '100%',
        cursor: 'pointer',
        background: (el, s) => (s.slide === 4 ? 'teal' : 'inkBorder'),
        onClick: (e, el, s) => s.update({ slide: 4 })
      },
      DotSix: {
        tag: 'span',
        boxSize: 'Y',
        round: '100%',
        cursor: 'pointer',
        background: (el, s) => (s.slide === 5 ? 'teal' : 'inkBorder'),
        onClick: (e, el, s) => s.update({ slide: 5 })
      },
      DotSeven: {
        tag: 'span',
        boxSize: 'Y',
        round: '100%',
        cursor: 'pointer',
        background: (el, s) => (s.slide === 6 ? 'teal' : 'inkBorder'),
        onClick: (e, el, s) => s.update({ slide: 6 })
      },
      DotEight: {
        tag: 'span',
        boxSize: 'Y',
        round: '100%',
        cursor: 'pointer',
        background: (el, s) => (s.slide === 7 ? 'teal' : 'inkBorder'),
        onClick: (e, el, s) => s.update({ slide: 7 })
      }
    },
    NextButton: {
      extends: 'Button',
      text: '{{ next2 | polyglot }}',
      theme: 'primary',
      padding: 'Y A',
      round: 'Z',
      show: (el, s) => s.slide < 7,
      onClick: (e, el, s) => s.update({ slide: s.slide + 1 })
    },
    FinishButton: {
      extends: 'Button',
      text: '{{ getInTouch | polyglot }}',
      theme: 'primary',
      padding: 'Y A',
      round: 'Z',
      show: (el, s) => s.slide === 7,
      onClick: (e, el, s) => s.update({ slide: 0 })
    }
  }
}
